import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart, User, Menu, X, LogOut, LogIn } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ openContactModal }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
  };

  const handleLoginClick = () => {
    navigate('/login');
    setIsMenuOpen(false);
  };

  const handleDashboardClick = () => {
    navigate('/dashboard');
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-gradient-to-r from-fsf-secondary via-fsf-secondary via-30% to-fsf-secondary text-white shadow-2xl sticky top-0 z-50 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          {/* Logo et nom */}
          <div className="flex items-center space-x-3 sm:space-x-4 group">
            <div className="flex items-center justify-center w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 bg-white rounded-lg  group-hover:shadow-xl transition-all duration-300 group-hover:rotate-12 p-2.5">
              <img src="/Logo_FSF.png" alt="Logo FSF" className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300" />
            </div>
            <div>
              {/* <h1 className="text-2xl sm:text-3xl lg:text-4xl text-left font-bold font-serif text-fsf-primary-dark">
                FSF
              </h1> */}
            </div>
          </div>

          {/* Navigation desktop */}
          <nav className="hidden lg:flex space-x-6">
            <Link to="/" className="px-4 py-2 rounded-lg text-white bg-fsf-secondary hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm">
              Accueil
            </Link>
            <Link to="/about" className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm">
              À propos
            </Link>
            <Link to="/galerie" className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm">
              Galerie
            </Link>
            <Link to="/ressources" className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm">
              Ressources
            </Link>
            <Link to="/evenements" className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm">
              Événements
            </Link>
            <Link to="/prieres" className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm">
              Prières
            </Link>
            <button 
              onClick={openContactModal}
              className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm"
            >
              Contact
            </button>
            {/* Bouton faire un don */}
            {/* <Link 
              to="/don"
              className="px-4 py-2 text-white rounded-lg bg-gradient-to-r from-blue-600 to-amber-600 hover:from-blue-700 hover:to-amber-700 transition-all duration-300 font-medium shadow-lg hover:shadow-xl flex items-center space-x-2"
            >
              <Heart className="w-4 h-4" />
              <span>Faire un don</span>
              <span>⇾</span>
            </Link> */}
            
            {/* Section authentification */}
            {isAuthenticated ? (
              <div className="flex items-center space-x-4">
                <span className="text-sm">Connecté: {user?.first_name || user?.name} ({user?.role})</span>
                <Link
                  to="/cotisations"
                  className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm flex items-center space-x-2"
                >
                  <Heart className="w-4 h-4" />
                  <span>Cotisations</span>
                </Link>
                <button
                  onClick={handleDashboardClick}
                  className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium border-b-2 border-transparent hover:border-fsf-warm flex items-center space-x-2"
                >
                  <User className="w-4 h-4" />
                  <span>Dashboard</span>
                </button>
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 text-white rounded-lg hover:bg-white/10 hover:text-red-300 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-red-300 flex items-center space-x-2"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Déconnexion</span>
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                {/* Bouton faire un don */}
                <Link 
                  to="/don" className="rounded-lg font-bold text-white hover:bg-yellow-800 bg-gray-700 p-2"> Faire un don</Link>
                {/* <Link
                  to="/7-diners-en-amoureux"
                  className="rounded-lg font-bold text-white hover:bg-fsf-primary bg-fsf-secondary p-2 shadow-md"
                >
                  7 Dîners
                </Link> */}
                <button
                  onClick={handleLoginClick}
                  className="px-4 py-2 text-white rounded-lg bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 transition-all duration-300 font-medium shadow-lg hover:shadow-xl flex items-center space-x-2"
                >
                  <LogIn className="w-4 h-4" />
                  <span>Se connecter</span>
                </button>
                

                {/* Bouton de connexion rapide admin (temporaire) */}
                {/* <button
                  onClick={() => navigate('/login?auto=admin')}
                  className="px-3 py-1 text-xs text-white rounded bg-red-600 hover:bg-red-700"
                >
                  Admin
                </button> */}
              </div>
            )}
          </nav>

          {/* Bouton menu mobile */}
          <button
            className="lg:hidden p-3 rounded-lg hover:bg-white/10 transition-colors duration-300"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} className="text-fsf-warm" /> : <Menu size={28} className="text-fsf-warm" />}
          </button>
        </div>

        {/* Menu mobile */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-6 pb-4 border-t border-white/20 animate-fade-in-up">
            <div className="flex flex-col space-y-2 pt-4">
              <Link to="/" className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium">
                🏠 Accueil
              </Link>
              <Link to="/about" className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium">
                ℹ️ À propos
              </Link>
              <Link to="/galerie" className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium">
                📸 Galerie
              </Link>
              <Link to="/ressources" className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium">
                📚 Ressources
              </Link>
              <Link to="/evenements" className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium">
                📅 Événements
              </Link>
              <Link to="/prieres" className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium">
                🙏 Prières
              </Link>
              <button 
                onClick={openContactModal}
                className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium text-left w-full"
              >
                💌 Contact
              </button>
              {/* <Link 
                to="/don"
                className="px-4 py-3 rounded-lg text-white bg-gradient-to-r from-blue-600 to-amber-600 hover:from-blue-700 hover:to-amber-700 transition-all duration-300 font-medium text-center"
              >
                💝 Faire un don
              </Link> */}
              
              {/* Section authentification mobile */}
              {isAuthenticated ? (
                <>
                  <button
                    onClick={handleDashboardClick}
                    className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-fsf-warm transition-all duration-300 font-medium text-left w-full"
                  >
                    👤 Dashboard
                  </button>
                  <button
                    onClick={handleLogout}
                    className="px-4 py-3 text-white rounded-lg hover:bg-white/10 hover:text-red-300 transition-all duration-300 font-medium text-left w-full"
                  >
                    🚪 Déconnexion
                  </button>
                </>
              ) : (
                <button
                  onClick={handleLoginClick}
                  className="px-4 py-3 rounded-lg text-white bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 transition-all duration-300 font-medium text-center w-full"
                >
                  🔑 Se connecter
                </button>
              )}
            </div>
          </nav>
        )}
      </div>


    </header>
  );
};

export default Header;